module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_check-77a53ef96bc5b261d6695790f946593f.svg";